module.exports = __webpack_public_path__ + "img/gld_gbt73_1985.prt.65e22f3f.jpg";